import React,{useEffect} from 'react'
import Layout from '../Layout.jsx'
import { useNavigate } from 'react-router-dom'
import Contact from '../../Components/LandingPage/Contact.jsx'
const ContactUsPage = () => {
    const navigate=useNavigate();
    
    
  return (
    <Layout>
      <Contact/>
    </Layout>
  )
}

export default ContactUsPage;
